// XP pricing table -- keep prices in sync with the selected variant.
//
// Stock PDPs let each variant carry its own price, but snippets/xp-pricing-table.liquid
// can only render one variant's numbers server-side. That snippet also emits a
// #xp-pricing-variant-data JSON block holding every variant's already-formatted cell
// strings, so toggling a color swatch here is a pure text swap -- no money math in JS,
// no risk of drifting from Liquid's rounding/format.
(function () {
  var priceData;
  var asLowData;

  function readJSONBlock(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getPriceData() {
    if (priceData === undefined) priceData = readJSONBlock('xp-pricing-variant-data');
    return priceData;
  }

  // The "As low as" line above the table is rendered from one variant too, and
  // snippets/xp-aslow-variant-data.liquid precomputes the rest the same way.
  function getAsLowData() {
    if (asLowData === undefined) asLowData = readJSONBlock('xp-aslow-variant-data');
    return asLowData;
  }

  function applyVariant(variantId) {
    applyTable(variantId);
    applyAsLow(variantId);
  }

  function applyTable(variantId) {
    var data = getPriceData();
    if (!data) return;
    var prices = data[variantId];
    if (!prices) return;

    // form-product.liquid renders the table up to three times (desktop/mobile
    // duplicates), so update every copy on the page, not just the first.
    // Cells are matched by data-xp-tier ("base", "1", "2"...), not position, because
    // the MOQ rules in xp-pricing-table.liquid can drop the base column -- a tier
    // with no cell on the page is just skipped.
    document.querySelectorAll('[data-xp-price-row]').forEach(function (row) {
      var cellValues = prices[row.getAttribute('data-xp-price-row')];
      if (!cellValues) return;
      row.querySelectorAll('td[data-xp-tier]').forEach(function (cell) {
        var value = cellValues[cell.getAttribute('data-xp-tier')];
        if (value !== undefined) cell.textContent = value;
      });
    });
  }

  function applyAsLow(variantId) {
    var data = getAsLowData();
    if (!data) return;
    var amount = data[variantId];
    if (!amount) return;

    // The unit label ("per pack" / "per wristband") sits outside this span and
    // is product-level, so only the amount is swapped.
    document.querySelectorAll('[data-xp-aslow-price]').forEach(function (el) {
      el.textContent = amount;
    });
  }

  // Delegated so it works no matter when the swatches are rendered, and without
  // touching the existing change handlers in custom-js-product.js /
  // custom-js-silicon-product.js.
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var radio = target.closest('.variant-radio');
    if (!radio || !radio.checked) return;
    var variantId = radio.getAttribute('data-variant-id');
    if (variantId) applyVariant(variantId);
  });
})();
